import script from "./BalCircle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalCircle.vue?vue&type=script&setup=true&lang=ts"

import "./BalCircle.vue?vue&type=style&index=0&id=2485db2c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2485db2c"]])

export default __exports__